export const notifications = {
  en: {
    title: "Inbox",
    unreadNotifications: "unread notifications",
    markAllRead: "Mark all notifications as read",
    markAllReadShort: "Mark all read",
    noNotifications: "No notifications",
    allCaughtUp: "You're all caught up!",
    notifications: "Notifications",
    unread: "unread",
    loadingNotifications: "Loading notifications",
    noNotificationsLabel: "No notifications",
    viewAll: "View all notifications",
  },
  es: {
    title: "Bandeja de Entrada",
    unreadNotifications: "notificaciones sin leer",
    markAllRead: "Marcar todas las notificaciones como leídas",
    markAllReadShort: "Marcar todo como leído",
    noNotifications: "Sin notificaciones",
    allCaughtUp: "¡Estás al día!",
    notifications: "Notificaciones",
    unread: "sin leer",
    loadingNotifications: "Cargando notificaciones",
    noNotificationsLabel: "Sin notificaciones",
    viewAll: "Ver todas las notificaciones",
  },
};
